import axios, { AxiosError, AxiosResponse } from "axios";
import axiosInstance from "../index";

export type LoginCheckV2Props = {
    login: string;
    password: string;
    redirect?: string | null;
}

export type LoginCheckV2Error = {
    error: string;
    jwt: string;
    fields: {
        errors: string[];
        request_id: string | null | undefined;
        message?: string | null | undefined;
    },
    message: string;
}
export const loginCheck = async ({ login, password }: LoginCheckV2Props): Promise<any> => {
    try {
        const { data } = await axiosInstance.post('/hub/auth/login', {
            username: login,
            password,
            branding: 'boursedirect'
        });

        return Promise.resolve(data);
    } catch(err) {
        if (axios.isAxiosError(err) && err?.response) {
            return Promise.reject(err as AxiosError<{response: AxiosResponse<LoginCheckV2Error>}>);
        }
        return Promise.reject(err);
    }
}

/**
 * Creates a user subscription by sending a POST request to the '/auth/member/register' endpoint.
 * @return {Promise<any>} A promise that resolves with the result of the request or rejects with an error.
 */

export const userSubscription = async (civility: string, phone: string, firstname: string, lastname: string, birthname: string, email: string, password: string): Promise<any> => {
    try {
        const result = await axiosInstance.post('/hub/auth/member/register', {
            'civility': civility,
            'email': email,
            'first_name': firstname.trim(),
            'last_name': lastname.trim(),
            'birth_name': birthname.trim(),
            'mobile_phone': phone,
            'pwd': password,
            'membership': false,
            'is_company': true,
            'brand': 'boursedirect'
        })
        return Promise.resolve(result);
    } catch (error) {
        return Promise.reject(error)
    }
}

/**
 * Retrieves the user roles from the server.
 *
 * @return {Promise<any>} A Promise that resolves to the user roles data.
 */
export const authUserRoles = async (): Promise<any> => {
    try {
        const { data } = await axiosInstance.get<{name: string}>(`/hub/auth/roles`);
        return Promise.resolve(data);
    } catch (err) {
        return Promise.reject(err);
    }
}

/**
 * Sends a password reset request to the specified email address.
 * @param {string} email - The email address to send the password reset request to
 * @returns {Promise<any>} A promise that resolves with the API response
 * @throws {Error} If sending the password reset request fails
 */
export const forgotPassword = async (email: string): Promise<any> => {
    try {
        const result = await axiosInstance.post('/hub/auth/forgot-password/request', {
            username: email,
            branding: 'boursedirect'
        })
        return Promise.resolve(result);
    } catch (error) {
        return Promise.reject(error)
    }
}
